<template>
  <div>
    <PageAllow controller="SubAccounts" action="index" />
    <Breadcrumbs :items="items" />
    <v-sheet class="transparent-background-color">
      <v-card class="page-card">
        <v-card-title class="mx-3">
          {{ $t("AbcSubAccount.title") }}
          <v-spacer></v-spacer>
        </v-card-title>
        <v-progress-linear :indeterminate="loading"></v-progress-linear>
        <v-card-text>
          <v-container>
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-right">
                {{ $t("AbcSubAccount.application") + $t("Global.colon") }}
              </v-col>
              <v-col cols="9" md="7">
                {{ $t("AbcSubAccount.application_title") }}
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-right">
                {{ $t("AbcSubAccount.merchant_id") + $t("Global.colon") }}
              </v-col>
              <v-col cols="7" md="6">
                <v-text-field single-line v-model="settings.abc_merchant_id">
                </v-text-field>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-right">
                {{
                  $t("AbcSubAccount.sub_merchant_account_guarantee") +
                  $t("Global.colon")
                }}
              </v-col>
              <v-col cols="7" md="6">
                <v-text-field
                  single-line
                  v-model="settings.abc_sub_merchant_account_guarantee"
                >
                </v-text-field>
              </v-col>
              <v-col cols="2">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      small
                      color="action"
                      class="px-2 me-2 mb-1"
                      :dark="
                        settings &&
                        settings.abc_sub_merchant_account_guarantee &&
                        !sub_merchant_account_guarantee.balanceLoading
                      "
                      :loading="sub_merchant_account_guarantee.balanceLoading"
                      :disabled="
                        !settings ||
                        !settings.abc_sub_merchant_account_guarantee ||
                        sub_merchant_account_guarantee.balanceLoading
                      "
                      @click.stop="
                        getAbcBalance(
                          settings.abc_sub_merchant_account_guarantee,
                          sub_merchant_account_guarantee
                        )
                      "
                    >
                      {{
                        $t(
                          sub_merchant_account_guarantee.balance_get
                            ? "SubAccount.action.balance_get"
                            : "SubAccount.action.balance",
                          [sub_merchant_account_guarantee.balance]
                        )
                      }}
                    </v-btn>
                  </template>
                  <span>{{ $t("SubAccount.action.balance") }} </span>
                </v-tooltip>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-right">
                {{
                  $t("AbcSubAccount.sub_merchant_account_refund_out") +
                  $t("Global.colon")
                }}
              </v-col>
              <v-col cols="7" md="6">
                <v-text-field
                  single-line
                  v-model="settings.abc_sub_merchant_account_refund_out"
                >
                </v-text-field>
              </v-col>
              <v-col cols="2">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      small
                      color="action"
                      class="px-2 me-2 mb-1"
                      :dark="
                        settings &&
                        settings.abc_sub_merchant_account_refund_out &&
                        !sub_merchant_account_refund_out.balanceLoading
                      "
                      :loading="sub_merchant_account_refund_out.balanceLoading"
                      :disabled="
                        !settings ||
                        !settings.abc_sub_merchant_account_refund_out ||
                        sub_merchant_account_refund_out.balanceLoading
                      "
                      @click.stop="
                        getAbcBalance(
                          settings.abc_sub_merchant_account_refund_out,
                          sub_merchant_account_refund_out
                        )
                      "
                    >
                      {{
                        $t(
                          sub_merchant_account_refund_out.balance_get
                            ? "SubAccount.action.balance_get"
                            : "SubAccount.action.balance",
                          [sub_merchant_account_refund_out.balance]
                        )
                      }}
                    </v-btn>
                  </template>
                  <span>{{ $t("SubAccount.action.balance") }} </span>
                </v-tooltip>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-right">
                {{
                  $t("AbcSubAccount.sub_merchant_account_refund_in_account") +
                  $t("Global.colon")
                }}
              </v-col>
              <v-col cols="7" md="6">
                <v-text-field
                  single-line
                  v-model="settings.abc_sub_merchant_account_refund_in_account"
                >
                </v-text-field>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-right">
                {{
                  $t("AbcSubAccount.sub_merchant_account_refund_in_account_name") +
                  $t("Global.colon")
                }}
              </v-col>
              <v-col cols="7" md="6">
                <v-text-field
                  single-line
                  v-model="settings.abc_sub_merchant_account_refund_in_account_name"
                >
                </v-text-field>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-right">
                {{
                  $t("AbcSubAccount.sub_merchant_account_refund_in") +
                  $t("Global.colon")
                }}
              </v-col>
              <v-col cols="7" md="6">
                <v-text-field
                  single-line
                  v-model="settings.abc_sub_merchant_account_refund_in"
                >
                </v-text-field>
              </v-col>
              <v-col cols="2">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      small
                      color="action"
                      class="px-2 me-2 mb-1"
                      :dark="
                        settings &&
                        settings.abc_sub_merchant_account_refund_in &&
                        !sub_merchant_account_refund_in.balanceLoading
                      "
                      :loading="sub_merchant_account_refund_in.balanceLoading"
                      :disabled="
                        !settings ||
                        !settings.abc_sub_merchant_account_refund_in ||
                        sub_merchant_account_refund_in.balanceLoading
                      "
                      @click.stop="
                        getAbcBalance(
                          settings.abc_sub_merchant_account_refund_in,
                          sub_merchant_account_refund_in
                        )
                      "
                    >
                      {{
                        $t(
                          sub_merchant_account_refund_in.balance_get
                            ? "SubAccount.action.balance_get"
                            : "SubAccount.action.balance",
                          [sub_merchant_account_refund_in.balance]
                        )
                      }}
                    </v-btn>
                  </template>
                  <span>{{ $t("SubAccount.action.balance") }} </span>
                </v-tooltip>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-right">
                {{
                  $t("AbcSubAccount.sub_merchant_account_cash_account") +
                  $t("Global.colon")
                }}
              </v-col>
              <v-col cols="7" md="6">
                <v-text-field
                  single-line
                  v-model="settings.abc_sub_merchant_account_cash_account"
                >
                </v-text-field>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-right">
                {{
                  $t("AbcSubAccount.sub_merchant_account_cash_account_name") +
                  $t("Global.colon")
                }}
              </v-col>
              <v-col cols="7" md="6">
                <v-text-field
                  single-line
                  v-model="settings.abc_sub_merchant_account_cash_account_name"
                >
                </v-text-field>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-right">
                {{
                  $t("AbcSubAccount.sub_merchant_account_cash") +
                  $t("Global.colon")
                }}
              </v-col>
              <v-col cols="7" md="6">
                <v-text-field
                  single-line
                  v-model="settings.abc_sub_merchant_account_cash"
                >
                </v-text-field>
              </v-col>
              <v-col cols="2">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      small
                      color="action"
                      class="px-2 me-2 mb-1"
                      :dark="
                        settings &&
                        settings.abc_sub_merchant_account_cash &&
                        !sub_merchant_account_cash.balanceLoading
                      "
                      :loading="sub_merchant_account_cash.balanceLoading"
                      :disabled="
                        !settings ||
                        !settings.abc_sub_merchant_account_cash ||
                        sub_merchant_account_cash.balanceLoading
                      "
                      @click.stop="
                        getAbcBalance(
                          settings.abc_sub_merchant_account_cash,
                          sub_merchant_account_cash
                        )
                      "
                    >
                      {{
                        $t(
                          sub_merchant_account_cash.balance_get
                            ? "SubAccount.action.balance_get"
                            : "SubAccount.action.balance",
                          [sub_merchant_account_cash.balance]
                        )
                      }}
                    </v-btn>
                  </template>
                  <span>{{ $t("SubAccount.action.balance") }} </span>
                </v-tooltip>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col cols="3" class="font-weight-bold text-right">
                {{
                  $t("AbcSubAccount.abc_sub_account_enable") +
                  $t("Global.colon")
                }}
              </v-col>
              <v-col cols="9" md="7">
                <v-radio-group row v-model="settings.abc_sub_account_enable">
                  <v-radio :label="$t('Payment.off')" :key="0" :value="0" />
                  <v-radio :label="$t('Payment.on')" :key="1" :value="1" />
                </v-radio-group>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
      <v-card class="page-opts">
        <v-card-title>
          <v-row dense>
            <v-col cols="12">
              <!-- 保存 -->
              <v-btn color="success" block @click="save()">
                <v-icon small class="pe-1">fa-save</v-icon>
                {{ $t("miniDevelopProgram.save") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
      </v-card>
    </v-sheet>
  </div>
</template>

<script>
import Setting from "@/api/settings";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import SubAccount from "@/api/sub_accounts";
import { mapState } from "vuex";

export default {
  components: {
    PageAllow,
    Breadcrumbs,
  },

  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("SettingNav.split"),
        disabled: false,
        href: "/settings/sub-account-settings/sub-account-type",
      },
      {
        text: i18n.t("SettingNav.splitInterface"),
        disabled: false,
        href: "/settings/sub-account-settings/sub-account-setting-port",
      },
    ],
    ...mapState(["loading"]),
  },

  data: () => ({
    settings: {},
    sub_merchant_account_guarantee: {
      balanceLoading: false,
      balance_get: false,
      balance: 0,
    },
    sub_merchant_account_refund_out: {
      balanceLoading: false,
      balance_get: false,
      balance: 0,
    },
    sub_merchant_account_refund_in: {
      balanceLoading: false,
      balance_get: false,
      balance: 0,
    },
    sub_merchant_account_cash: {
      balanceLoading: false,
      balance_get: false,
      balance: 0,
    },
    serverErrors: [],
  }),

  mounted() {
    this.getAbcPayFromAPI();
  },

  methods: {
    getAbcPayFromAPI() {
      Setting.getSettings({
        keys: [
          "abc_sub_account_enable",
          "abc_merchant_id",
          "abc_sub_merchant_account_guarantee",
          "abc_sub_merchant_account_refund_out",
          "abc_sub_merchant_account_refund_in_account",
          "abc_sub_merchant_account_refund_in_account_name",
          "abc_sub_merchant_account_refund_in",
          "abc_sub_merchant_account_cash_account",
          "abc_sub_merchant_account_cash_account_name",
          "abc_sub_merchant_account_cash",
        ],
        parse: false,
      }).then(
        function (response) {
          if (response.data.status.isOK()) {
            delete response.data.settings.distribution_district_unique_enable;
            response.data.settings.abc_sub_account_enable = parseInt(
              response.data.settings.abc_sub_account_enable
            ); //发请求时为免商户号转换传了parse: false，结果中enable要特别做转换
            this.settings = response.data.settings;
          }
        }.bind(this)
      );
    },
    getAbcBalance(third_account_number, item) {
      item.balanceLoading = true;
      SubAccount.getAbcBalance(third_account_number).then(
        function (response) {
          item.balanceLoading = false;
          if (response.data.status.isOK()) {
            if (response.data.balance.ReturnCode == "0000") {
              item.balance_get = true;
              item.balance = response.data.balance.Balance;
            } else {
              this.$snackbar.error(response.data.balance.ErrorMessage);
            }
          }
        }.bind(this)
      );
    },
    save() {
      const arr = [];
      for (let key in this.settings) {
        arr.push({ setting_key: key, setting_value: this.settings[key] });
      }
      Setting.batchSave(arr).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.$router.replace(
              "/settings/sub-account-settings/sub-account-setting-port"
            );
          }
        }.bind(this)
      );
    },
  },
};
</script>